import classNames from 'classnames';

import { getTabTestId, SimpleTabsProps } from '../tabs.type';

export const SimpleTabs = ({ tabs, onChange, activeTab }: SimpleTabsProps) => {
  return tabs.map((tab) => (
    <button
      key={tab.name}
      type='button'
      // Keyed on the id, not the label: E2E may not couple to translated copy (doc 13).
      data-testid={getTabTestId(tab.id)}
      className={classNames('text-subtitle-m whitespace-nowrap', {
        'text-tertiary hover:text-primary': tab.id !== activeTab,
        'text-primary': tab.id === activeTab,
      })}
      onClick={() => onChange(tab.id)}>
      {tab.name}
    </button>
  ));
};
